const $ = jQuery;

const Dots = {
  init: function () {
    const selectValue = document.querySelector(".orderby").value;
    const select = document.querySelector(".woocommerce-ordering");

    if (select && selectValue.length > 4) {
      const html = "<span class=dots>...<span>";

      const dots = document.createElement("div");
      dots.innerHTML = html;

      select.appendChild(dots.firstChild);
    }
  },
};

export default Dots;
